import {Component, OnInit} from '@angular/core';
import {ApiService} from '../../../services/api.service';
import _ from 'lodash';
import {LoginService} from '../../../services/login.service';
import {NotificationsService} from 'angular2-notifications';
import {ActivatedRoute} from '@angular/router';
import {DygraphsComponent} from '../zoomView/dygraphs/dygraphs.component';
import {ModalService} from '../../../services/modalService/modal.service';
import Dygraph from 'dygraphs';
import { TranslateService } from '@ngx-translate/core';
import { BackendTranslateService } from '../../../helper/backend-translate.service';
@Component({
  selector: 'app-denials-day',
  templateUrl: './denials-day.component.html',
  styleUrls: ['./denials-day.component.css', '../myreports.component.css']
})
export class DenialsDayComponent implements OnInit {
    chartData: any = [];
   ruid: string;
   isLicense: string;
   isGraphEnabled = true;
  options: any = {
    height: 400,
    animatedZooms: true,
    legend: 'always',
    pointSize: 4,
    axes: {
      y: {
        axisLabelFormatter: function (x) {
          return Math.round(x) == x ? x : '';
        }
      }
    }
  };
  isLoggedIn = false;
  currentUser: any;
  features: any;
  feature: any = 'All';
  dg: any;
  someRange = 100;
  sideSlideConfig = {
    step: 1,
    connect: true,
    range: {
      min: 10,
      max: 300
    },
    direction: 'rtl',
    orientation: 'vertical'
  };
  minValue: number;
  maxValue: number;

  constructor(private apiService: ApiService,
              private loginService: LoginService,
              private route: ActivatedRoute,
              private notifications: NotificationsService,
              private modalService: ModalService,
              private translate: TranslateService,
              private backendTranslate: BackendTranslateService) {
  }

  ngOnInit() {
    this.loginService.isLoggedIn()
      .subscribe((isLoggedIn) => {
          this.currentUser = isLoggedIn;
          this.isLoggedIn = this.currentUser.isLoggedIn;
      });

    this.route.queryParams.subscribe(params => {
      if (params.ruid) {
        this.ruid = params.ruid;
        const that = this;
        this.apiService.getSummary(this.ruid)
          .subscribe((res) => {
            this.isLicense = res.isLicense;
            if (!res.isLicense) {
              this.reportsData();
            }
          }, (error) => {
              this.notifications.error(
                this.translate.instant('common.error'),
                this.apiService.getMessageFromError(error, this.translate.instant('reports.invalidRuid'))
              );
          });
      }
    });
  }

  title(): string {
       return `${this.translate.instant('reports.denailsDay.denials')} (${this.chartData.length})`;
  }

  reportsData() {
    this.apiService.getDenialByDay(this.ruid)
      .subscribe((res) => {
        for (const key of Object.keys(res.featureIdAndDescription)) {
          const translations = this.backendTranslate.translateMessage(res.featureIdAndDescription[key]);
          if (translations.split('.')[0] !== 'apiMessages') {
            res.featureIdAndDescription[key] = translations;
          }
        }
        res.labels.forEach((elem, index) => {
          if(elem) {
	          const translations = this.backendTranslate.translateMessage(elem);
	          if (translations.split('.')[0] !== 'apiMessages') {
	            res.labels[index] = translations;
	          }
	      }
        });
        this.features = res.featureIdAndDescription;
        if (res.data.length > 0) {
            this.chartData = _.map(res.data, (innerArray) => {
                return _.map(innerArray, _.ary(parseInt, 1));
            });
            this.chartData = _.map(this.chartData, (element) => {
                element[0] = new Date(element[0]);
                return element;
            });
            this.options.labels = res.labels;
            this.options.labelsUTC = true;
            // console.log(document.getElementById('graphdiv'));
            if (document.getElementById('graphdiv')) {
                // console.log('here');
                this.dg = new Dygraph(document.getElementById('graphdiv'), this.chartData, this.options);
                this.dg.ready(function () {
                    this.resize();
                });
                // console.log(this.dg);
                this.updateRange(this, this.dg);
            }
        } else {
        	this.isGraphEnabled = false;
        }
      }, (err) => {
          this.notifications.error(
            this.translate.instant('common.error'),
            this.apiService.getMessageFromError(err, this.translate.instant('reports.deniedFeatures.fail'))
          );
      });
  }

  zoomView() {
      if (this.chartData.length === 0) {
          return;
      }
    this.modalService.open(DygraphsComponent, {
      data: this
    }).subscribe(model => {
    });
  }

    remapDygraph($event, data, dgChart) {
        if (dgChart != this.dg){ //If executed from zoomed view, update report view too
            this.remapDygraph($event, this, this.dg);
        }

        let selector = $event.target;
        let all = selector.value == 'All'; 
        let allFeatures = selector.value == 'AllFeatures';
        let total = selector.value == 'Total';
        let selected = selector.selectedIndex;
        if (allFeatures) {
            selected = -1;
        } else if (total || all) {
            selected -= 1;
        }
        let visibility = [];
        _.forEach(dgChart.user_attrs_.labels, (value, key) => {
            visibility[key - 1] = all || allFeatures;
            if (data.feature == value) {
                visibility[key - 1] = true;
            }
        });
        if (allFeatures) {
            visibility[dgChart.numColumns() - 2] = false;
            visibility[dgChart.numColumns() - 1] = false;
        }
        dgChart.updateOptions({visibility: visibility, valueRange: null});
        data.someRange = 100;
        this.updateRange(data, dgChart);
    }

    updateRange(data, dgChart) {
        let range = dgChart.yAxisRange();
        data.minValue = range[0];
        data.maxValue = range[1];
    }

  onChange(event) {
    const max = this.maxValue * event / 100;
    this.dg.updateOptions({valueRange: [this.minValue, max]});
  }

}



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/reports/myReports/denials-day/denials-day.component.ts